import Helper from './Helper';

class Accordion {
  constructor(config = {}) {
    const {
      accordions,
    } = config;
    this.accordions = Array.prototype.slice.call(document.querySelectorAll(accordions));
    this.currentEl = null;
    if(this.accordions && this.accordions.length !== 0){
      this.bindEvents(); 
    }
  }

  bindEvents() {
    this.accordions.forEach(el => {
      el.addEventListener('click', (e) => {
        const ac_content = el.parentNode.nextElementSibling;
        if(el.classList.contains('active')){
          Helper.slideClose(ac_content);
          el.classList.remove('active');
          ac_content.classList.remove('active');
        } else{
          el.classList.add('active');
          ac_content.classList.add('active');
          Helper.slideOpen(ac_content, true);
        }
      });
    });
  }

}

export default Accordion;
